import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const SectionRawHtml = ({ body }) => {
  return (
    <div className="px-8 py-14 md:px-24 xl:px-36 2xl:px-60 lg:py-12 w-full">
      <div className="flex flex-col gap-11 lg:flex-row max-w-7xl mx-auto">
          <div>{parse(body)}</div>
      </div>
    </div>
  );
};

SectionRawHtml.propTypes = {
  body: PropTypes.string
};

export default SectionRawHtml;
